import React, { useEffect, useState } from "react";
import { Outlet } from "react-router-dom";
import useAuth from "../hooks/useAuth";
import useAxiosPrivate from "../hooks/useAxiosPrivate";
import useRefreshToken from "../hooks/useRefreshToken";
import CircularProgress from "@mui/material/CircularProgress";
import Box from "@mui/material/Box";

export default function PersistLogin() {
  const refresh = useRefreshToken();
  const { accessToken, setUser } = useAuth();
  const [loading, setLoading] = useState(true);
  const axiosPrivate = useAxiosPrivate();

  useEffect(() => {
    let isMounted = true;

    const verifyUser = async () => {
      try {
        await refresh();
        setTimeout(async () => {
          const { data } = await axiosPrivate.get("user");
          setUser(data);
        }, 50);
      } catch (error) {
        console.log(error);
      } finally {
        isMounted && setLoading(false);
      }
    };

    !accessToken ? verifyUser() : setLoading(false);

    return () => {
      isMounted = false;
    };
  }, []);

  return loading ? (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
      }}
    >
      <CircularProgress color="info" />
    </Box>
  ) : (
    <Outlet />
  );
}
